module.exports = __webpack_public_path__ + "img/2975f7f.jpg";